/**
 * BulkTextToolPage — eigenständiges Tool "Bulk-Texte" (T6b/E1b/E2b).
 *
 * Tabs "Erstellen" / "Läufe". Intake über `?products=` (Zubringer-Muster
 * `BatchGenerationFormV2.tsx:28`), aktiver Tab über `?tab=runs`.
 */

import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/v2/ui'

import { CreateRunSection } from './wizard/CreateRunSection'
import { IssuesEntryCard } from './IssuesEntryCard'
import { RunsListSection } from './RunsListSection'

export function BulkTextToolPage() {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()

  const productIds = useMemo(() => {
    const ids = searchParams.get('products')
    if (!ids) return []
    return ids.split(',').filter(Boolean).slice(0, 50)
  }, [searchParams])

  const initialChannelIds = useMemo(() => {
    const ch = searchParams.get('channel')
    return ch ? [ch] : undefined
  }, [searchParams])

  const activeTab = searchParams.get('tab') === 'runs' ? 'runs' : 'create'

  const handleTabChange = (value: string) => {
    const next = new URLSearchParams(searchParams)
    next.set('tab', value)
    setSearchParams(next, { replace: true })
  }

  const handleIssuesLoaded = (ids: string[]) => {
    const next = new URLSearchParams(searchParams)
    next.set('products', ids.join(','))
    setSearchParams(next, { replace: true })
  }

  return (
    <div className="space-y-6 p-6">
      <h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">
        {t('channelContent.title')}
      </h1>

      <Tabs value={activeTab} onValueChange={handleTabChange} variant="pills">
        <TabsList>
          <TabsTrigger value="create">{t('channelContent.tool.tabCreate')}</TabsTrigger>
          <TabsTrigger value="runs">{t('channelContent.tool.tabRuns')}</TabsTrigger>
        </TabsList>

        <TabsContent value="create" className="space-y-6">
          {productIds.length === 0 && <IssuesEntryCard onProductsLoaded={handleIssuesLoaded} />}
          <CreateRunSection productIds={productIds} initialChannelIds={initialChannelIds} />
        </TabsContent>

        <TabsContent value="runs">
          <RunsListSection />
        </TabsContent>
      </Tabs>
    </div>
  )
}
